<template>
  <v-select
    class="pb-3 pr-0"
    v-show="show"    
    v-model="selectedSetting"
    :items="items"
    @change="emitSettingsChangedEvent"
    :solo="!filled"
    v-focus
    :filled="filled"    
    :ref="uid"
    aria-label="Filtermodus"
    return-object
    flat
    dense
    label="Filtermodus"
    hide-details
    item-text="name"
  ></v-select>
</template>

<script>
export default {
  name: "FilterSettings",
  data: () => {
    return {
      selectedSetting: null
    }
  },
  props: {
    value: Object,
    items: Array,
    show: Boolean,
    filled: Boolean
  },
  methods: {
    emitSettingsChangedEvent: function (newValue) {      
      this.$emit("setting-changed", newValue);
    }
  },
  watch: {
    show: function(newVal) {
      if (newVal) {
        this.$nextTick(() => this.$refs[this.uid].focus())
      }
    }
  },
  mounted: function() {          
      this.selectedSetting = this.value;
  }
}
</script>

<style>
</style>